import { t, useI18n } from "@bookingcom/lingojs-react";
import { useAirlinesCampaignPerformanceQuery } from "../../../hooks/useAirlinesCampaignPerformanceQuery";
import { useCampaignPerformanceQuery } from "../../../hooks/useCampaignPerformanceQuery";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { useAuth } from "../../../hooks/useAuth";
import { ChartNoData } from "../ChartNoData";
import { DiscountedBookingsChart } from "./DiscountedBookingsChart";

export type DiscountedBookingsChartLoaderProps = {
  from: Date;
  to: Date;
};

export const DiscountedBookingsChartLoader = ({ from, to }: DiscountedBookingsChartLoaderProps) => {
  const i18n = useI18n();
  const { isAirlineUser } = useAuth();
  const useQuery = isAirlineUser ? useCampaignPerformanceQuery : useAirlinesCampaignPerformanceQuery;
  const { selectedAirline } = useSelectedAirline({ useSuspense: true });
  const { data: metrics } = useQuery({
    from,
    to,
    metrics: ["DISCOUNTED_BOOKINGS_SOLD"],
    airlineCode: selectedAirline?.code,
  });

  const discountedBookingsMetric = metrics.find((metric) => metric.metadata.metricName === "DISCOUNTED_BOOKINGS_SOLD");
  if (!discountedBookingsMetric) {
    return <ChartNoData titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_name"))} />;
  }

  return <DiscountedBookingsChart metric={discountedBookingsMetric} />;
};
